import React, { Component, Fragment, Children, cloneElement, createElement } from 'react';

export const Detail = ({tag, children, ...otherProps}) => createElement(tag, otherProps, children);

export const Item = ({tag = "div", isOpen, onExpand, children, ...otherProps}) => (<Fragment>
  {createElement(tag, otherProps, Children.map(children, (child, key) => {
    return child.type !== Detail && cloneElement(child, { key });
  }))}
  {Children.map(children, (child, key) => {
    return isOpen && child.type === Detail && cloneElement(child, { tag, key, ...child.props });
  })}
</Fragment>);

export default class extends Component {
  constructor (props) {
    super(props);

    this.state = {
      def: true,
      isOpen: !!props.isOpen
    };
  }

  static getDerivedStateFromProps(props, state) {
    if (state.def && props.isOpen !== state.isOpen) {
      return {
        isOpen: props.isOpen
      };
    }
    return null;
  }

  toggleOpen = () => this.setState(state => ({
    def: false,
    isOpen: !state.isOpen
  }));

  toggle = e => {
    const { async = false, onClick = () => {}, onExpand = () => Promise.resolve() } = this.props;
    const { isOpen } = this.state;
    onClick(e);

    if (async) {
      onExpand(!isOpen).then(this.toggleOpen)
    } else if (onExpand(!isOpen)) {
      this.toggleOpen();
    }
  };

  render () {
    const { children, ...otherProps } = this.props;
    return (<Item {...otherProps} isOpen={this.state.isOpen} onClick={this.toggle}>
      {children}
    </Item>);
  }
}


// WEBPACK FOOTER //
// ./src/components/ExpandableItem.js